import AddPageTab from './AddPageTab';
import DetailPageTab from './DetailPageTab';
import React from 'react';
interface propsTypes {
  isEditable?: void | any;
  cancelEditable?: void | any;
  disableTabPanes?: void | any;
  detail?: any;
  cancelAndSave?: void | any;
  tableCurrentData?: any;
}
const DetailPageInfo = (props: propsTypes) => {
  return (
    <>
      {!props.detail ? (
        <AddPageTab cancelAndSave={props.cancelAndSave} />
      ) : (
        <DetailPageTab
          disableTabPanes={props.disableTabPanes}
          cancelAndSave={props.cancelAndSave}
          tableCurrentData={props.tableCurrentData}
          isEditable={props.isEditable}
          cancelEditable={props.cancelEditable}
        />
      )}
    </>
  );
};
export default DetailPageInfo;
